import { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import ROUTES from '../../../../config/routes'
import { createTransitFromEns } from '../api/createTransitFromEns'

function useCreateTransitFromEnsModal() {
  const [transitOperationId, setTransitOperationId] = useState<number | null>(null)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isError, setIsError] = useState(false)

  const navigate = useNavigate()
  const { t } = useTranslation()

  const open = useCallback((id: number) => {
    setTransitOperationId(id)
  }, [])

  const close = useCallback(() => {
    setTransitOperationId(null)
    setIsError(false)
  }, [])

  const submit = useCallback(async (withFiles: boolean) => {
    if (!transitOperationId) throw new Error('Missing transit operation ID')

    try {
      setIsSubmitting(true)
      setIsError(false)

      const transitOperationCopy = await createTransitFromEns(transitOperationId, withFiles)

      navigate(`${ROUTES.transitP5}/${transitOperationCopy.id}`)
      toast.success(t('messages.duplicate', {
        context: 'successful',
        replace: { id: transitOperationCopy.id },
      }))
      close()
    } catch (err) {
      setIsError(true)
    } finally {
      setIsSubmitting(false)
    }
  }, [close, navigate, t, transitOperationId])

  const confirm = useCallback(async () => {
    await submit(true)
  }, [submit])

  const reject = useCallback(async () => {
    await submit(false)
  }, [submit])

  return {
    transitOperationId,
    isOpen: transitOperationId != null,
    open,
    close,
    confirm,
    reject,
    isSubmitting,
    isError,
  }
}

export default useCreateTransitFromEnsModal
